(() => {
	const forms = document.querySelectorAll("[data-aramex-tracking-form]");
	if (!forms.length) return;

	const formatDate = (value) => {
		if (!value) return "";
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return value;
		return date.toLocaleString();
	};

	const renderResult = (container, data) => {
		const html = `
      <dl>
        <dt>Tracking number</dt><dd>${data.trackingNumber || "-"}</dd>
        <dt>Status</dt><dd>${data.status || "-"}</dd>
        <dt>Location</dt><dd>${data.location || "-"}</dd>
        <dt>Date</dt><dd>${formatDate(data.date)}</dd>
        <dt>Weight</dt><dd>${data.weight || "-"}</dd>
      </dl>
    `;
		container.innerHTML = html;
		container.classList.add("is-visible");
	};

	forms.forEach((form) => {
		const status = form.querySelector("[data-aramex-status]");
		const result = form.querySelector("[data-aramex-result]");
		const trackingInput = form.querySelector('input[name="trackingNumber"]');
		const orderIdInput = form.querySelector('input[name="orderId"]');
		const emailInput = form.querySelector('input[name="email"]');

		const setStatus = (message, isError = false) => {
			if (!status) return;
			status.textContent = message;
			status.style.color = isError
				? "rgb(var(--color-error-rgb, 220 38 38))"
				: "inherit";
		};

		form.addEventListener("submit", async (event) => {
			event.preventDefault();
			if (!trackingInput || !orderIdInput || !emailInput) return;

			const trackingNumber = trackingInput.value.trim();
			const orderId = orderIdInput.value.trim();
			const email = emailInput.value.trim();

			if (!trackingNumber && !orderId) {
				setStatus("Enter your tracking number or order ID.", true);
				return;
			}

			const apiBase = (form.dataset.apiBase || "").trim();
			const apiKey = (form.dataset.apiKey || "").trim();
			const proxyPath = (form.dataset.proxyPath || "").trim();
			let endpoint = "";
			const headers = {};

			if (apiBase) {
				const identifier = trackingNumber || orderId;
				endpoint = `${apiBase.replace(/\/$/, "")}/${encodeURIComponent(identifier)}`;
			} else if (proxyPath) {
				const identifier = trackingNumber || orderId;
				endpoint = `${proxyPath.replace(/\/$/, "")}/${encodeURIComponent(identifier)}`;
			} else {
				setStatus("Tracking service is not configured yet.", true);
				return;
			}

			if (email) {
				const url = new URL(endpoint, window.location.origin);
				url.searchParams.set("email", email);
				endpoint = url.toString();
			}

			setStatus("Checking tracking status...");
			if (result) {
				result.classList.remove("is-visible");
				result.innerHTML = "";
			}

			try {
				const response = await fetch(endpoint, { method: "GET", headers });
				let data = null;
				try {
					data = await response.json();
				} catch (error) {
					data = null;
				}

				if (!response.ok) {
					const message =
						(data && (data.message || data.errorMessage)) ||
						`Unable to fetch tracking status (${response.status}).`;
					setStatus(message, true);
					return;
				}

				const normalized = Array.isArray(data) ? data[0] : data;
				if (!normalized || normalized.found === false) {
					setStatus(
						"Tracking number not found. Please double-check and try again.",
						true,
					);
					return;
				}

				setStatus("Latest update");
				if (result) {
					renderResult(result, normalized);
				}
			} catch (error) {
				setStatus(
					"Unable to reach tracking service. Please try again later.",
					true,
				);
			}
		});
	});
})();
